
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'productupdates-ui',
  currentProjectVersion: 'static-1.7812',
  depVersions: {
  "productupdates-ui": "static-1.7812",
  "apollo-dlb": "static-3.41",
  "chatspot-client-types": "static-1.8775",
  "chatspot-core": "static-1.16132",
  "client-types": "static-1.376",
  "copilot-plugins": "static-1.6818",
  "copilot-toolkit": "static-1.6845",
  "csstype": "static-1.38",
  "cssUtils": "static-1.520",
  "data-fetching-client": "static-1.8523",
  "foundations-components-test-utils": "static-1.3596",
  "graphql": "static-1.59",
  "head-dlb": "static-1.4043",
  "hs-test-utils": "static-1.6906",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10406",
  "I18n": "static-7.1394",
  "jasmine-runner": "static-1.5307",
  "msw": "static-1.39",
  "quartz": "static-1.5651",
  "quartz-core": "static-1.4870",
  "react-dlb": "static-1.54",
  "react-router-dom": "static-5.26",
  "superstore": "static-1.3668",
  "ui-components-test-utils": "static-1.4544",
  "webpack-env": "static-1.54",
  "ai-components-ui-library": "static-1.5371",
  "amplitude-session-replay-browser": "static-1.33",
  "apollo-stack-hubspot": "static-3.43",
  "enviro": "static-4.306",
  "feedback-loader": "static-1.26716",
  "foundations-assets": "static-1.3814",
  "foundations-components": "static-1.6111",
  "foundations-theming": "static-1.3212",
  "history": "static-4.47",
  "hub-http": "static-1.4807",
  "HubStyle": "static-2.10714",
  "icons": "static-2.592",
  "immer": "static-1.33",
  "moment": "static-3.26",
  "PortalIdParser": "static-2.284",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4818",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15473",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4405",
  "react-virtualized": "static-2.74",
  "redux": "static-4.16",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.3613",
  "sanitize": "static-1.3274",
  "sanitize-text": "static-1.7069",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.464",
  "transmute": "static-2.29",
  "trellis-ecosystem": "static-1.4848",
  "ui-addon-avatars": "static-2.8157",
  "ui-addon-calendars": "static-2.4254",
  "ui-addon-draggable": "static-3.3781",
  "ui-addon-i18n": "static-1.9809",
  "ui-addon-opt": "static-4.7517",
  "ui-addon-react-router-dom": "static-1.8506",
  "ui-images": "static-2.868",
  "UIComponents": "static-3.7353",
  "usage-tracker": "static-1.6369",
  "usage-tracker-core": "static-1.6219",
  "usage-tracker-session-replay": "static-1.4055",
  "hs-promise-rejection-tracking": "static-1.4356",
  "raven-hubspot": "static-1.5125",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3063",
  "immutable": "static-2.19",
  "metrics-js": "static-1.8459",
  "bend-plugin-trellis-migration": "static-1.2526",
  "bend-plugin-quartz": "static-1.1928",
  "quartz-webpack": "static-1.1875",
  "ts-schema": "static-1.3213",
  "ai-rendering-library": "static-1.5592",
  "foundations-theming-specialty": "static-1.929",
  "ui-brand-identity-lib": "static-1.9283",
  "sassPrefix": "static-1.132",
  "fast-json-stable-stringify": "static-1.4",
  "HeadJS": "static-2.580",
  "framer-motion": "static-1.41",
  "hs-test-utils-bend-plugin": "static-1.2017",
  "testing-library": "static-1.121",
  "i18n-data": "static-1.198",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3241",
  "quartz-core-utils": "static-1.2518",
  "dispatcher": "static-1.113",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.652",
  "hub-http-shared-msw-handlers": "static-1.7178",
  "hubspotter-http": "static-1.3655",
  "hubspotter-http-shared-msw-handlers": "static-1.7176",
  "mobile-manifest-mixins": "static-1.351",
  "platform-navigation-bootstrap": "static-1.11321",
  "ui-fonts": "static-1.332",
  "autolinker": "static-3.11",
  "ContentUtils": "static-1.63698",
  "foundations-theming-base": "static-1.2197",
  "hs-story-utils": "static-1.8279",
  "bend-plugin-foundations-components": "static-1.2380",
  "floating-ui": "static-1.29",
  "react-aria": "static-1.39",
  "tanstack-table": "static-1.23",
  "bend-plugin-foundations-theming": "static-1.1695",
  "marketplace-ui-apps-core": "static-1.13367",
  "marketplace-ui-common": "static-1.14831",
  "storybook-react": "static-1.4",
  "trellis-story-utils": "static-1.3455",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.47",
  "SharedI18nStrings": "static-1.162",
  "avatar-components": "static-1.1361",
  "customer-data-filters": "static-1.48243",
  "customer-data-filters-ui": "static-1.34428",
  "customer-data-objects": "static-1.6522",
  "customer-data-reference-ui-components": "static-1.11899",
  "ExportDialog": "static-6.9280",
  "highlight.js": "static-1.45",
  "markdown-it": "static-1.6",
  "react-table": "static-1.15",
  "reporting-action-components": "static-1.36820",
  "reporting-ui-components": "static-2.59488",
  "reporting-visualizations": "static-1.54288",
  "ui-addon-teams": "static-1.19920",
  "ui-addon-upgrades": "static-9.16155",
  "file-manager-components": "static-1.19061",
  "FileManagerLib": "static-1.34702",
  "react-colorpicker": "static-2.9154",
  "platform-infra-nav-components": "static-1.6775",
  "cms-field-types": "static-1.3685",
  "content-icons-ui": "static-1.1930",
  "underscore": "static-1.8",
  "developer-experience-shared-components": "static-1.9096",
  "hs-lodash": "static-4.45",
  "immutable-less": "static-1.3443",
  "marketplace-ui-client-types": "static-1.12238",
  "ui-addon-iframeable": "static-1.7790",
  "ui-addon-integrations-directory-panel": "static-2.6912",
  "ui-extensibility-client-types": "static-1.3055",
  "ui-universal-auth": "static-1.7706",
  "ai-settings-ui-library": "static-1.6031",
  "laboratory-lib": "static-3.6140",
  "nav-meta": "static-1.25728",
  "react-window": "static-1.13",
  "self-service-api": "static-1.9103",
  "atom": "static-1.4088",
  "customer-data-objects-ui-components": "static-1.11793",
  "customer-data-property-utils": "static-1.6834",
  "customer-data-ui-utilities": "static-1.8619",
  "deep-diff": "static-1.5",
  "FormUrlGenerator": "static-2.3617",
  "framework-builder-read-service-client": "static-1.3134",
  "framework-data-schema-quick-fetch": "static-1.5669",
  "framework-data-schema-resolvers": "static-1.5764",
  "inbound-db-meta-service-client": "static-1.2868",
  "inbound-db-properties-service-client": "static-1.3013",
  "lodash": "static-4.7",
  "PatternValidationJS": "static-1.437",
  "property-description-translator": "static-1.2756",
  "property-translator": "static-1.4304",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.7056",
  "reference-resolvers-lite": "static-1.6897",
  "crm-message-bus": "static-1.37406",
  "customer-data-filters-ui-msw-helpers": "static-1.16861",
  "content-assistance-lib": "static-1.6428",
  "dashboard-lib": "static-1.76408",
  "getting-started-shared-tasks": "static-1.13230",
  "hubspot-prosemirror": "static-1.14111",
  "integrations-lib": "static-1.11052",
  "prosemirror": "static-1.13",
  "reporting-data": "static-1.62211",
  "reporting-snowflake": "static-1.50832",
  "share-with-third-party-component-lib": "static-1.7564",
  "ui-business-units-lib": "static-1.7789",
  "user-context": "static-1.4083",
  "frontend-preferences-client": "static-1.6782",
  "highcharts": "static-8.81",
  "reporting-plugins": "static-1.7215",
  "reporting-reports": "static-1.61894",
  "usage-tracker-container": "static-1.6359",
  "crm-object-map": "static-1.2213",
  "feature-store-service-types": "static-1.3592",
  "growth-monetization-service-types": "static-1.3599",
  "salesImages": "static-1.501",
  "upgrade-management-service-types": "static-1.3583",
  "media-bridge-lib": "static-1.16856",
  "video-data-lib": "static-1.30072",
  "FileManagerCore": "static-1.34561",
  "FileManagerImages": "static-1.32212",
  "apps-service-types": "static-1.2981",
  "oauth-service-types": "static-1.3194",
  "magpie-lib": "static-1.4558",
  "navigation-messaging": "static-1.3418",
  "hs-promise-utils": "static-1.4433",
  "react-dnd-compat": "static-1.3557",
  "react-immutable-render-mixin": "static-1.9",
  "persist-promise": "static-1.2639",
  "batch-promise": "static-1.481",
  "crm-pipelines-api-client-types": "static-1.3193",
  "external-options-client-types": "static-1.3188",
  "react-transition-group": "static-1.7",
  "ui-addon-video-player": "static-1.7679",
  "ui-coaching-tips": "static-1.23516",
  "onboarding-scopes": "static-1.5459",
  "redux-actions": "static-3.7",
  "ui-asset-management-lib": "static-1.9208",
  "emoji-mart": "static-3.4",
  "growth-payments-core": "static-1.21507",
  "knowledge-content-types": "static-1.7757",
  "payment-link-components": "static-1.19187",
  "rich-text-lib": "static-1.17593",
  "ui-addon-emoji-picker": "static-1.8844",
  "ui-shepherd-react": "static-3.8963",
  "flux-actions": "static-1.276",
  "integrations-error-boundary-lib": "static-1.8467",
  "integrations-tracking-lib": "static-1.4422",
  "native-integrations-shared-strings": "static-1.6726",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9369",
  "rxjs": "static-5.10",
  "reporting-client-types": "static-1.1969",
  "hubspot-apollo-client": "static-1.3722",
  "reporting-datasets-permissions-lib": "static-1.8250",
  "getting-started-shared-tasks-store": "static-1.12348",
  "campaign-roi-lib": "static-1.3680",
  "crm-index-visualization-object-layout": "static-1.1078",
  "crm-links": "static-1.5002",
  "crm-object-search-query-utilities": "static-1.6541",
  "customer-data-properties": "static-1.46366",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7262",
  "audio-components": "static-1.4565",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.3446",
  "video-components": "static-1.8422",
  "video-embed": "static-1.30911",
  "idb-keyval": "static-1.21",
  "magpie-types": "static-1.4018",
  "simple-logging-lib": "static-1.1933",
  "growth-onboarding-feedback-components": "static-1.5359",
  "timezone-utils": "static-2.4139",
  "commerce-analytics-service-client": "static-1.2602",
  "commerce-tours-lib": "static-1.3818",
  "growth-onboarding-reliability": "static-1.4051",
  "onboarding-tours": "static-1.14525",
  "sales-checkout-service-client": "static-1.2614",
  "data-token-picker": "static-1.14264",
  "universal-page-editor-lib": "static-1.1849",
  "apollo-link-hub-http": "static-2.3666",
  "location-customization-utils-lib": "static-1.4459",
  "calling-cross-tab-library": "static-1.18108",
  "calling-lifecycle-messages": "static-1.52202",
  "commerce-products-lib": "static-1.5344",
  "conditional-properties-service-client": "static-1.2998",
  "google-libphonenumber": "static-1.12",
  "inbounddb-objects-service-types": "static-1.3285",
  "object-builder-ui-client": "static-1.42926",
  "pipeline-validation-client-types": "static-1.2971",
  "smart-property-lib": "static-1.1363",
  "ui-addon-form-validation": "static-1.9921",
  "immerable": "static-1.3046",
  "social-insights-client-types": "static-1.18064",
  "outpost": "static-1.3253",
  "growth-data-modal": "static-1.4126",
  "onboarding-tours-client": "static-1.3396",
  "growth-onboarding-confetti": "static-1.1989",
  "growth-onboarding-next-action-utils": "static-1.92",
  "navigation-components": "static-1.14091",
  "ui-shepherd-tracker": "static-1.6344",
  "crm-record-cards-service-types": "static-1.2828",
  "calling-internal-common": "static-1.30132",
  "shared-worker-versioning": "static-1.9968",
  "calling-global-api": "static-1.58525",
  "calling-lifecycle-internal": "static-1.59907",
  "customer-data-tracking": "static-1.5729",
  "products-iframe-lib": "static-1.3630",
  "products-ui-components-shared-msw-handlers": "static-1.7561",
  "breeze-intelligence-kit": "static-1.4147",
  "fsm": "static-1.2628",
  "policy-lib": "static-1.5672",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7324",
  "calling-error-reporting": "static-1.30138",
  "calling-usage-tracker": "static-1.5392",
  "calling-orchestration-shared-library": "static-1.30598",
  "conversations-skeleton-state": "static-1.6281",
  "multi-currency-client-types": "static-1.2855",
  "sales-views-client-types": "static-1.3213",
  "calling-orchestration-schema": "static-1.30823"
},
  depPathPrefixes: {
  "productupdates-ui": "/productupdates-ui/static-1.7812",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "chatspot-client-types": "/chatspot-client-types/static-1.8775",
  "chatspot-core": "/chatspot-core/static-1.16132",
  "client-types": "/client-types/static-1.376",
  "copilot-plugins": "/copilot-plugins/static-1.6818",
  "copilot-toolkit": "/copilot-toolkit/static-1.6845",
  "csstype": "/csstype/static-1.38",
  "cssUtils": "/cssUtils/static-1.520",
  "data-fetching-client": "/data-fetching-client/static-1.8523",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3596",
  "graphql": "/graphql/static-1.59",
  "head-dlb": "/head-dlb/static-1.4043",
  "hs-test-utils": "/hs-test-utils/static-1.6906",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10406",
  "I18n": "/I18n/static-7.1394",
  "jasmine-runner": "/jasmine-runner/static-1.5307",
  "msw": "/msw/static-1.39",
  "quartz": "/quartz/static-1.5651",
  "quartz-core": "/quartz-core/static-1.4870",
  "react-dlb": "/react-dlb/static-1.54",
  "react-router-dom": "/react-router-dom/static-5.26",
  "superstore": "/superstore/static-1.3668",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4544",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5371",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.33",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "enviro": "/enviro/static-4.306",
  "feedback-loader": "/feedback-loader/static-1.26716",
  "foundations-assets": "/foundations-assets/static-1.3814",
  "foundations-components": "/foundations-components/static-1.6111",
  "foundations-theming": "/foundations-theming/static-1.3212",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.4807",
  "HubStyle": "/HubStyle/static-2.10714",
  "icons": "/icons/static-2.592",
  "immer": "/immer/static-1.33",
  "moment": "/moment/static-3.26",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4818",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15473",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4405",
  "react-virtualized": "/react-virtualized/static-2.74",
  "redux": "/redux/static-4.16",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.3613",
  "sanitize": "/sanitize/static-1.3274",
  "sanitize-text": "/sanitize-text/static-1.7069",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.464",
  "transmute": "/transmute/static-2.29",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4848",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.4254",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.3781",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9809",
  "ui-addon-opt": "/ui-addon-opt/static-4.7517",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8506",
  "ui-images": "/ui-images/static-2.868",
  "UIComponents": "/UIComponents/static-3.7353",
  "usage-tracker": "/usage-tracker/static-1.6369",
  "usage-tracker-core": "/usage-tracker-core/static-1.6219",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4055",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
  "raven-hubspot": "/raven-hubspot/static-1.5125",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.8459",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2526",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1928",
  "quartz-webpack": "/quartz-webpack/static-1.1875",
  "ts-schema": "/ts-schema/static-1.3213",
  "ai-rendering-library": "/ai-rendering-library/static-1.5592",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.929",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.9283",
  "sassPrefix": "/sassPrefix/static-1.132",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "HeadJS": "/HeadJS/static-2.580",
  "framer-motion": "/framer-motion/static-1.41",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2017",
  "testing-library": "/testing-library/static-1.121",
  "i18n-data": "/i18n-data/static-1.198",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3241",
  "quartz-core-utils": "/quartz-core-utils/static-1.2518",
  "dispatcher": "/dispatcher/static-1.113",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.652",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7178",
  "hubspotter-http": "/hubspotter-http/static-1.3655",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7176",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.351",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11321",
  "ui-fonts": "/ui-fonts/static-1.332",
  "autolinker": "/autolinker/static-3.11",
  "ContentUtils": "/ContentUtils/static-1.63698",
  "foundations-theming-base": "/foundations-theming-base/static-1.2197",
  "hs-story-utils": "/hs-story-utils/static-1.8279",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2380",
  "floating-ui": "/floating-ui/static-1.29",
  "react-aria": "/react-aria/static-1.39",
  "tanstack-table": "/tanstack-table/static-1.23",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.13367",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.14831",
  "storybook-react": "/storybook-react/static-1.4",
  "trellis-story-utils": "/trellis-story-utils/static-1.3455",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.47",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "avatar-components": "/avatar-components/static-1.1361",
  "customer-data-filters": "/customer-data-filters/static-1.48243",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34428",
  "customer-data-objects": "/customer-data-objects/static-1.6522",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11899",
  "ExportDialog": "/ExportDialog/static-6.9280",
  "highlight.js": "/highlight.js/static-1.45",
  "markdown-it": "/markdown-it/static-1.6",
  "react-table": "/react-table/static-1.15",
  "reporting-action-components": "/reporting-action-components/static-1.36820",
  "reporting-ui-components": "/reporting-ui-components/static-2.59488",
  "reporting-visualizations": "/reporting-visualizations/static-1.54288",
  "ui-addon-teams": "/ui-addon-teams/static-1.19920",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16155",
  "file-manager-components": "/file-manager-components/static-1.19061",
  "FileManagerLib": "/FileManagerLib/static-1.34702",
  "react-colorpicker": "/react-colorpicker/static-2.9154",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6775",
  "cms-field-types": "/cms-field-types/static-1.3685",
  "content-icons-ui": "/content-icons-ui/static-1.1930",
  "underscore": "/underscore/static-1.8",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9096",
  "hs-lodash": "/hs-lodash/static-4.45",
  "immutable-less": "/immutable-less/static-1.3443",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.12238",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7790",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6912",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3055",
  "ui-universal-auth": "/ui-universal-auth/static-1.7706",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6031",
  "laboratory-lib": "/laboratory-lib/static-3.6140",
  "nav-meta": "/nav-meta/static-1.25728",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.9103",
  "atom": "/atom/static-1.4088",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11793",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6834",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8619",
  "deep-diff": "/deep-diff/static-1.5",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3617",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3134",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5669",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5764",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2868",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3013",
  "lodash": "/lodash/static-4.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "property-description-translator": "/property-description-translator/static-1.2756",
  "property-translator": "/property-translator/static-1.4304",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.7056",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6897",
  "crm-message-bus": "/crm-message-bus/static-1.37406",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16861",
  "content-assistance-lib": "/content-assistance-lib/static-1.6428",
  "dashboard-lib": "/dashboard-lib/static-1.76408",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.13230",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.14111",
  "integrations-lib": "/integrations-lib/static-1.11052",
  "prosemirror": "/prosemirror/static-1.13",
  "reporting-data": "/reporting-data/static-1.62211",
  "reporting-snowflake": "/reporting-snowflake/static-1.50832",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7564",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7789",
  "user-context": "/user-context/static-1.4083",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6782",
  "highcharts": "/highcharts/static-8.81",
  "reporting-plugins": "/reporting-plugins/static-1.7215",
  "reporting-reports": "/reporting-reports/static-1.61894",
  "usage-tracker-container": "/usage-tracker-container/static-1.6359",
  "crm-object-map": "/crm-object-map/static-1.2213",
  "feature-store-service-types": "/feature-store-service-types/static-1.3592",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3599",
  "salesImages": "/salesImages/static-1.501",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3583",
  "media-bridge-lib": "/media-bridge-lib/static-1.16856",
  "video-data-lib": "/video-data-lib/static-1.30072",
  "FileManagerCore": "/FileManagerCore/static-1.34561",
  "FileManagerImages": "/FileManagerImages/static-1.32212",
  "apps-service-types": "/apps-service-types/static-1.2981",
  "oauth-service-types": "/oauth-service-types/static-1.3194",
  "magpie-lib": "/magpie-lib/static-1.4558",
  "navigation-messaging": "/navigation-messaging/static-1.3418",
  "hs-promise-utils": "/hs-promise-utils/static-1.4433",
  "react-dnd-compat": "/react-dnd-compat/static-1.3557",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "persist-promise": "/persist-promise/static-1.2639",
  "batch-promise": "/batch-promise/static-1.481",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3193",
  "external-options-client-types": "/external-options-client-types/static-1.3188",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7679",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.23516",
  "onboarding-scopes": "/onboarding-scopes/static-1.5459",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9208",
  "emoji-mart": "/emoji-mart/static-3.4",
  "growth-payments-core": "/growth-payments-core/static-1.21507",
  "knowledge-content-types": "/knowledge-content-types/static-1.7757",
  "payment-link-components": "/payment-link-components/static-1.19187",
  "rich-text-lib": "/rich-text-lib/static-1.17593",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8844",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8963",
  "flux-actions": "/flux-actions/static-1.276",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8467",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4422",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6726",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9369",
  "rxjs": "/rxjs/static-5.10",
  "reporting-client-types": "/reporting-client-types/static-1.1969",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3722",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.8250",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12348",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.3680",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.1078",
  "crm-links": "/crm-links/static-1.5002",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6541",
  "customer-data-properties": "/customer-data-properties/static-1.46366",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7262",
  "audio-components": "/audio-components/static-1.4565",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.3446",
  "video-components": "/video-components/static-1.8422",
  "video-embed": "/video-embed/static-1.30911",
  "idb-keyval": "/idb-keyval/static-1.21",
  "magpie-types": "/magpie-types/static-1.4018",
  "simple-logging-lib": "/simple-logging-lib/static-1.1933",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5359",
  "timezone-utils": "/timezone-utils/static-2.4139",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2602",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3818",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4051",
  "onboarding-tours": "/onboarding-tours/static-1.14525",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2614",
  "data-token-picker": "/data-token-picker/static-1.14264",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1849",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3666",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4459",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18108",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.52202",
  "commerce-products-lib": "/commerce-products-lib/static-1.5344",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2998",
  "google-libphonenumber": "/google-libphonenumber/static-1.12",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3285",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.42926",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2971",
  "smart-property-lib": "/smart-property-lib/static-1.1363",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9921",
  "immerable": "/immerable/static-1.3046",
  "social-insights-client-types": "/social-insights-client-types/static-1.18064",
  "outpost": "/outpost/static-1.3253",
  "growth-data-modal": "/growth-data-modal/static-1.4126",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3396",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1989",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.92",
  "navigation-components": "/navigation-components/static-1.14091",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6344",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2828",
  "calling-internal-common": "/calling-internal-common/static-1.30132",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9968",
  "calling-global-api": "/calling-global-api/static-1.58525",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.59907",
  "customer-data-tracking": "/customer-data-tracking/static-1.5729",
  "products-iframe-lib": "/products-iframe-lib/static-1.3630",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7561",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4147",
  "fsm": "/fsm/static-1.2628",
  "policy-lib": "/policy-lib/static-1.5672",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7324",
  "calling-error-reporting": "/calling-error-reporting/static-1.30138",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5392",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30598",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6281",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2855",
  "sales-views-client-types": "/sales-views-client-types/static-1.3213",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30823"
}
};
